import React, { useState, useRef } from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import Axios from "axios";
import { KPI_SEARCH_URL } from "../../../api/urls";
import SearchComponent from "../../../ui/SearchComponent";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { get } from "../../../utils/get";
import { KPI_URL } from "../../../api/urls";
import { postEndpoint, GetHook, putEndpoint } from "../../../api/api";
import { useLocation, useParams } from "react-router-dom";
import Modal from "../../../ui/Modal";
import { ManageDeleteFormatter } from "../../../ui/ManageDeleteFormatter";
import { Button } from "../../../ui/Button";
import { CircleIcon } from "../../../assets/svg/CircleIcon";
import { ScorecardIcon } from "../../../assets/svg/ScorecardIcon";
import { OrganisationTypeIcon } from "../../../assets/svg/OrganisationTypeIcon";
import Header from "../components/Header";
import { DELETE_KPI_URL } from "../../../api/urls";
import { Formik } from "formik";

interface Kpi {
  kpi_name: string;
  perspective: string;
  id: string;
  objective_name: string;
}

const GlobalSearchKpi = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [kpis, setKpis] = useState<Kpi[]>([]);
  const [message, setMessage] = useState<string>('');
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { id }: any = useParams();
  const [step, setStep] = useState(1);
  const [kpiId, setKpiId] = useState();

  const formRef: any = useRef<any>(null);

  const initialValues = {
    name: "",
    score_type: "",
    weight: "",
    baseline: "",
    optimisation: "",
    kpi_type: "",
    supported_kpi: "",
    alignment: "",
    notes: "",
  };

  const { reload } = GetHook(
    `${KPI_URL}?objective_id=${id}`
  );

  const location = useLocation();
  const accessToken = localStorage.getItem("access_token");


  const setEdit = (kpi) => {
    setIsEdit(true);
    setEditData(kpi);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setKpiId(undefined);
    setStep(1);
  };

  const handleSubmit = (values: any) => {
    
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setKpis([]);
  }

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          Axios.delete(`${DELETE_KPI_URL}?kpi_id=${id}`, {
            headers: {
              'Authorization': `Bearer ${accessToken}`
            }
          })
            .then((res) => {
              setKpis(
                kpis.filter((kpi: any) => kpi?.id != id)
              );
              toast.success("KPI has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error('KPI cannot be deleted!'));
        }
      }
    });
  };

  const handleKpiSearch = async () => {
    try {
      setKpis([]);
      const response = await Axios.get(`${KPI_SEARCH_URL}?name=${searchQuery.toLowerCase()}`);
      if (response.data.kpis && response.data.kpis.length > 0) {
        setKpis(response.data.kpis as Kpi[]);
        setMessage(response.data.message);
      } else {
        setKpis([]);
        setMessage('No KPIs found');
      }
    } catch (error) {
      toast.error('Error searching for KPI');
      setKpis([]);
      setMessage('Error searching for KPI');
    }
  };

  return (
    <GlobalSettingsContainer>
      <HeaderContainer>
        <TitleText>GlobalSearch</TitleText>
      </HeaderContainer>
      <Container>
        <SearchComponent
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onSearch={handleKpiSearch}
          onClear={handleClearSearch}
        />
        <KpiList>
          {kpis.map((kpi) => (
            <KpiItem key={kpi.kpi_name}>
              <KpiContent>
                <KpiTitle>{kpi.kpi_name}</KpiTitle>
                <KpiSubtitle>Perspective - {kpi.perspective}</KpiSubtitle>
                <KpiSubtitle>Objective - {kpi.objective_name}</KpiSubtitle>
              </KpiContent>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                {/* <ManageDeleteFormatter
                  showEdit={() => setEdit(kpi)}
                  handleDelete={() => handleDelete(kpi.id)}
                /> */}
              </span>
            </KpiItem>
          ))}
        </KpiList>
      </Container>
    </GlobalSettingsContainer>
    );
  };
  
  const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `;

  const GlobalSettingsContainer = styled.div`
    display: grid;
    grid-template-rows: 5em auto;
    background-color: #fff;
  `;

  const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.3em;
    border-bottom: 1px solid rgba(55, 81, 255, 0.1);
  `;

  const KpiList = styled.ul`
    list-style-type: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  `;

  const KpiItem = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5em 1.4em;
    background-color: #f7f9fc;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 1em;
    text-decoration: none;
    width: 100%;
    max-width: 600px;
    &:hover {
      background-color: #e0e7ff;
    }
    &.active {
      background-color: #ebefff;
    }
  `;

  const KpiContent = styled.div`
    display: flex;
    flex-direction: column;
  `;

  const KpiTitle = styled.span`
    font-size: 16px;
    font-weight: bold;
  `;

  const KpiSubtitle = styled.span`
    font-size: 14px;
    color: #666;
  `;

  const WizzardHeader = styled.div`
    display: flex;
    flex-direction: row;
    /* justify-content: space-between; */
    align-items: center;
    border: 2px solid rgba(76, 92, 251, 0.1);
    border-radius: 1em;
    margin-top: 1em;
    margin-bottom: 1em;
  `;

  const HeaderItem = styled.button<{ enabled: boolean }>`
    display: flex;
    font-size: 12;
    font-weight: 600;
    align-items: center;
    background-color: ${(props) => (props.enabled ? "#EBEFFF" : "#fff")};
    color: #01A8CE;
    padding: 1em 1.5em 1em 1.5em;
    border-radius: 1em;
    width: 100%;
    box-shadow: 0px 0px 0px transparent;
    border: 1px solid transparent;
    text-shadow: 0px 0px 0px transparent;
    border-color: ${(props) =>
      props.enabled ? "rgba(1,168,206,1)" : "none"};
    opacity: ${(props) => (props.enabled ? 1 : 0.4)};
    ${TitleText} {
      padding-left: 1em;
      color: #01A8CE;
      font-size: 12px;
    }
    &:focus {
      outline: none;
    }
  `;

  const Footer = styled.footer`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1em;
  `;

  const ButtonWithBorder = styled(Button)<{ disabled: boolean }>`
    border: 2px solid #01A8CE;
    padding: 0.3em 4em;
    margin-left: auto;
    margin-right: 1em;
    opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  `;

  const SmallButton = styled(Button)`
    padding: 0.4em 4em;
    border: 2px solid #01A8CE;
  `;
  
  export default GlobalSearchKpi;